'use client';

import { cn } from '@zealot/ui/lib/utils';
import type * as React from 'react';

type LabelProps = React.ComponentProps<'label'> & {
  required?: boolean;
};

const Label = ({ className, required, children, ...props }: LabelProps) => {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex select-none items-center gap-2 font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-70',
        className,
      )}
      {...props}
    >
      {children}
      {required && <span className="text-destructive">*</span>}
    </label>
  );
};

export { Label };
